import { useRootStore } from 'stores/RootStore'
import { useEffect } from 'react'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

export const FeatureFlagLoader = () => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const featureFlags = useRootStore().featureFlags

  useEffect(() => {
    featureFlags.setReady(false)
    featureFlags.clearFlags()
    featureFlags.load()
  }, [featureFlags, currentWorkspaceId])

  return null
}
